import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import ProductsView from '../views/ProductsView.vue'
import ContactUsView from '../views/ContactUsView.vue'
import ProductView from '../views/ProductView.vue'
import NewsIndex from '../views/NewsIndex.vue'
import NewsView from '../views/NewsView.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsView
  },
  {
    path: '/news',
    name: 'news-index',
    component: NewsIndex
  },
  {
    path: '/news/:slug',
    name: 'news-view',
    component: NewsView
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUsView
  },
  {
    path: '/product/:slug',
    name: 'product',
    component: ProductView
  }
]

export default routes
